module.exports = __webpack_public_path__ + "img/diamond.be5030ca.webp";